<template lang="pug">
  include /mixins
  +b.VALIDATION-OBSERVER(
    ref="validator",
    v-slot="{ valid }",
    tag="form",
  )
    ui-loader(v-if='isLoad')
    +b.ds-panel
      +e.element--offset_vertical.--indent_inside
        +b.ds-caption--size_2xs.--size_sm-xl.P.tt-space_mt--6-xl {{ _('Если вы зарегистрированый клиент, введите Ваш номер телефона и пароль. ') }}
        +b.ds-caption--size_2xs.--size_sm-xl.tt-space_mt--4.--0-xl.P {{ _('Если вы еще не зарегистрированы на нашем сайте, то перейдите в раздел “Новый покупатель” и заполните информацию. ') }}
    +b.g-row
      +b.g-cell.g-cols--12.tt-space_mt--6
        phone-input(
          :rules="'required|phone'",
          :input-label='labels.phone'
          v-model='form.username',
          ref='phone'
          name='username'
          tabindex='1'
        )
    .relative
      +b.non-field-error-label.LABEL(v-if="non_field_errors") {{ non_field_errors[0] }}
    +b.g-row--justify_end
      +b.g-cell.g-cols--12.--4-xl.tt-space_mt--10
        token-confirmation-check(
          :token='form.username'
          :additional-data='{ is_new_user: false, is_authcode: true, source: $options.ORDER_ANONIM_REGISTRATION_PHONE_SOURCE }'
          :action='login'
        )
          template(#default='{ is_confirmed, sendCode }')
            +b.tt-button--for-input.BUTTON(
              type='submit'
              :disabled='isLoad',
              tabindex='1'
              @click.prevent='validate(sendCode)'
            )
              +e.title.P {{ _('войти') }}

</template>
<script>
import { tokenObtainRequest } from '@api/auth.service'
import loginMixin from '@app/Forms/mixins/login'
import { ORDER_ANONIM_REGISTRATION_PHONE_SOURCE } from '@/consts'

export default {
  name: 'OrderAuth',
  mixins: [loginMixin],
  ORDER_ANONIM_REGISTRATION_PHONE_SOURCE,
  data() {
    return {
      url: window.password_set_url,
      is_recovery: true,
      localdata: {},
    }
  },
  methods: {
    async validate(action) {
      this.$refs.validator.reset()
      this.is_recovery = false
      this.$nextTick(async () => {
        const isValid = (await this.$refs.validator.validate())
        if (!isValid) return
        action()
      })
      // this.$emit('validate', { valid, step })
    },
    goToPasswordSetPage(id) {
      const data = {
        phone: this.form.username,
        id,
      }
      window.location.href = `${this.url}?_state=${btoa(JSON.stringify(data))}`
    },
    async send() {
      return tokenObtainRequest.execute({}, this.localdata).then(() => {
        window.location.reload()
      })
    },
    async login(id, code) {
      this.localdata = {
        username: id,
        password: code,
      }
      return this.submit(true, this.form)
    },
  },
}
</script>
